export const TOKEN_STORAGE_KEY = 'ptcmAuthToken';
export const MEMBER_SECRET_KEY = 'ptcmMemberSecret';
export const DEVICE_UUID_KEY = 'ptcmDeviceUuid';
export const FAMILY_CODE_KEY = 'ptcmFamilyCode';

export const SHARE_OPTIONS = [
  { value: 0, label: 'Non concerné.e' },
  { value: 1, label: "Je ne m'en occupe pas" },
  { value: 2, label: "Je m'en occupe moins que mon/ma partenaire" },
  { value: 3, label: "Je m'en occupe autant que mon/ma partenaire" },
  { value: 4, label: "Je m'en occupe plus que mon/ma partenaire" },
  { value: 5, label: "Je m'en occupe à 100%" }
];

export const BURDEN_OPTIONS = [
  { value: 0, label: 'Non concerné.e' },
  { value: 1, label: "J'aime" },
  { value: 2, label: 'Ça ne me pèse pas' },
  { value: 3, label: 'Ça me pèse un peu' },
  { value: 4, label: 'Ça me pèse beaucoup' }
];

export const THOUGHT_OPTIONS = [
  { value: -1, label: 'Personne' },
  { value: 0, label: 'Mon/ma partenaire' },
  { value: 1, label: 'Nous deux' },
  { value: 2, label: 'Moi' }
];
